<div fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row">
    <h2>Aktywuj blokadę logowania</h2>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" >
    <mat-form-field class="dict-form-field" fxFlex="100">
      <mat-label>Czas do wylogowania użytkowników</mat-label>
      <mat-select [required]="true"  [formControl]="minutesStartAtControl">
        <mat-option value="5">5 minut</mat-option>
        <mat-option value="10"  >10 minut</mat-option>
        <mat-option value="15"  >15 minut</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" >
    <mat-form-field class="dict-form-field" fxFlex="100">
      <mat-label>Przewidywany czas niedostępności systemu</mat-label>
      <mat-select [required]="true"  [formControl]="minutesEndAtControl">
        <mat-option value="10"  >10 minut</mat-option>
        <mat-option value="15"  >15 minut</mat-option>
        <mat-option value="30"  >30 minut</mat-option>
        <mat-option value="60"  >godzina</mat-option>
        <mat-option value="90"  >1,5 godziny</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>

    <button
      mat-raised-button (click)="sendForm()" color="primary"
      [class.spinner]="processingRequest" [disabled]="processingRequest"
    >Aktywuj blokadę</button>
    <button (click)="closeDialog($event)" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
